import { addPublicURL } from './AddPublicURL';
/**
 * Function returns icon path with extension - default extension is svg
 * @param {string} icon - icon name
 * @param  {string} extension - extension of icon
 * @param {string} subfolder - path to icon sub folder
 * @returns {string} icon path in public folder
 */

export const getIconPath = (icon: string, extension?: string, subfolder?: string): string => {
  return addPublicURL(`/assets/icons${subfolder ? '/' + subfolder : ''}/${icon}${extension || '.svg'}`);
};

/**
 * Function returns picture path with extension - default extension is png
 * @param {string} picture - picture name
 * @param  {string} extension - extension of picture
 * @returns {string} picture path in public folder
 */

export const getPicturePath = (picture: string, extension?: string): string =>
  addPublicURL(`/assets/pictures/${picture}${extension || '.png'}`);
